import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Button,
  Chip,
  Stack,
  Grid,
  Box,
} from "@mui/material";
import moment from "moment";
import EntrevistasForm from "./EntrevistasForm";
import EntrevistasDelete from "./EntrevistasDelete";

const EntrevistasItem = (props) => {
  const {
    id,
    nombre_candidato,
    apellido_candidato,
    trabajo_candidato,
    dni_contacto,
    edad_candidato,
    telefono_candidato,
    user,
    nombre_entrevistador,
    apellido_entrevistador,
    fecha_entrevista,
    aprobado,
    observacion,
    como_llego_cv,
    forma_de_comunicarse,
    tiempo_de_incorporacion,
    algun_conocido,
    situacion_familiar,
    remuneracion_pretendida,
    referencias_laborales,
    linit_vigente,
    caducidad_linit,
    carnet_conducir_vigente,
    caducidad_carnet,
    puestoQueAplica,
    obtenerEntrevistas,
    id_entrevistador,
    id_candidato,
    mostrarAlertaTemporal,
    tipo_entrevista_desplegable,
    tipo_entrevista,
  } = props;
  const [isEditMode, setIsEditMode] = useState(false);
  const [openFormModal, setOpenFormModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [nuevoEstado, setNuevoEstado] = useState(null);

  const handleOpenFormModal = () => {
    setOpenFormModal(true);
  };

  const handleOpenDeleteModal = () => {
    setOpenDeleteModal(true);
  };

  const rrhh = localStorage.getItem("adminrrhh");
  const userLS = localStorage.getItem("user");

  return (
    <>
      {openFormModal && (
        <EntrevistasForm
          isEditMode={true}
          onClose={() => setOpenFormModal(false)}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          props={props}
          obtenerEntrevistas={obtenerEntrevistas}
          idCandidato={id_candidato}
          puestoQueAplica={puestoQueAplica}
        />
      )}
      {openDeleteModal && (
        <EntrevistasDelete
          estadoEntrevista={nuevoEstado}
          id_candidato={id_candidato}
          id={id}
          obtenerEntrevistas={obtenerEntrevistas}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          onClose={() => setOpenDeleteModal(false)}
        />
      )}

      <Card
        sx={{
          display: "flex",
          flexDirection: "column",

          padding: 2,
          borderRadius: 2,
          boxShadow: 3,
          width: 800,
          minWidth: 700,
          backgroundColor: "#ffffff",
          margin: "10px auto",
        }}
      >
        <CardContent sx={{ width: "100%" }}>
          <Grid container spacing={2}>
            {/* Columna 1 */}
            <Grid item xs={10}>
              {/* Candidato */}
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#333" }}
              >
                {nombre_candidato} {apellido_candidato}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              {/* Estado de la entrevista */}
              {rrhh === "1" && (
                <Chip
                  label={
                    aprobado === 1
                      ? "Aprobado"
                      : aprobado === 0
                      ? "Rechazado"
                      : "Pendiente"
                  }
                  color={
                    aprobado === 1
                      ? "success"
                      : aprobado === 0
                      ? "error"
                      : "default"
                  }
                />
              )}
            </Grid>
          </Grid>
          <Divider sx={{ my: 1 }} />
          {/* Info Personal */}
          <Grid container spacing={2}>
            {/* Columna 1 */}
            <Grid item xs={6}>
              <Stack spacing={1}>
                <Typography variant="body2" color="textSecondary">
                  <strong>DNI:</strong> {dni_contacto}
                </Typography>

                <Typography variant="body2" color="textSecondary">
                  <strong>Teléfono:</strong> {telefono_candidato}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Tipo de entrevista:</strong>{" "}
                  {tipo_entrevista ? tipo_entrevista : "-"}
                </Typography>
              </Stack>
            </Grid>

            {/* Columna 2 */}
            <Grid item xs={6}>
              <Stack spacing={1}>
                <Typography variant="body2" color="textSecondary">
                  <strong>Entrevistador:</strong> {nombre_entrevistador}{" "}
                  {apellido_entrevistador}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <strong>Fecha:</strong>{" "}
                  {moment(fecha_entrevista).format("DD-MM-YYYY")}
                </Typography>
              </Stack>
            </Grid>

            {/* Divider */}
            <Grid item xs={12}>
              <Divider sx={{ my: 1 }} />
            </Grid>
          </Grid>
          {(rrhh === "1" || user === userLS) && (
            <Grid container spacing={2}>
              {/* Columna 1 */}
              <Grid item xs={6}>
                <Stack spacing={1}>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Observación:</strong> {observacion}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Como llego el CV:</strong> {como_llego_cv}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Forma de comunicarse:</strong>{" "}
                    {forma_de_comunicarse}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Situación familiar:</strong> {situacion_familiar}
                  </Typography>
                </Stack>
              </Grid>

              {/* Columna 2 */}
              <Grid item xs={6}>
                <Stack spacing={1}>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Tiempo de incorporación:</strong>{" "}
                    {tiempo_de_incorporacion} días
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Conoce a alguien en la empresa:</strong>{" "}
                    {algun_conocido === 1 ? "Si" : "No"}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Remuneración pretendida:</strong> $
                    {remuneracion_pretendida}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <strong>Referencias laborales:</strong>{" "}
                    {referencias_laborales}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          )}

          {/* Mostrar los datos solo si el puesto es chofer */}
          {(rrhh === "1" || user === userLS) &&
            puestoQueAplica.toLowerCase() === "chofer" && (
              <>
                {/* Divider arriba de los datos del chofer */}
                <Divider sx={{ my: 2 }} />

                <Grid container spacing={2}>
                  {/* Columna 1 */}
                  <Grid item xs={6}>
                    <Stack spacing={1}>
                      <Typography variant="body2" color="textSecondary">
                        <strong>Linit vigente:</strong>{" "}
                        {linit_vigente === 1 ? "Si" : "No"}
                      </Typography>
                      {linit_vigente === 1 && (
                        <Typography variant="body2" color="textSecondary">
                          <strong>Fecha de caducidad LINIT:</strong>{" "}
                          {moment(caducidad_linit).format("DD/MM/YYYY")}
                        </Typography>
                      )}
                    </Stack>
                  </Grid>

                  {/* Columna 2 */}
                  <Grid item xs={6}>
                    <Stack spacing={1}>
                      <Typography variant="body2" color="textSecondary">
                        <strong>Carnet de conducir vigente:</strong>{" "}
                        {carnet_conducir_vigente === 1 ? "Si" : "No"}
                      </Typography>
                      {carnet_conducir_vigente === 1 && (
                        <Typography variant="body2" color="textSecondary">
                          <strong>Fecha de caducidad CARNET:</strong>{" "}
                          {moment(caducidad_carnet).format("DD/MM/YYYY")}
                        </Typography>
                      )}
                    </Stack>
                  </Grid>
                </Grid>
                <Divider sx={{ my: 2 }} />
              </>
            )}

          {/* Entrevista */}
          {(rrhh === "1" || user === userLS) && (
            <Box sx={{ display: "flex", justifyContent: "end", mt: 3 }}>
              <Divider sx={{ my: 2 }} />
              {rrhh === "1" && (
                <>
                  <Button
                    variant="outlined"
                    color={"success"}
                    entrevista
                    onClick={() => {
                      setNuevoEstado(1);
                      handleOpenDeleteModal();
                    }}
                    sx={{ margin: "auto 0px" }}
                  >
                    APROBAR ENTREVISTA
                  </Button>
                  <Button
                    variant="outlined"
                    color={"error"}
                    entrevista
                    onClick={() => {
                      setNuevoEstado(0);
                      handleOpenDeleteModal();
                    }}
                    sx={{ margin: "auto 20px" }}
                  >
                    Desaprobar entrevista
                  </Button>
                </>
              )}
              <Button
                variant="outlined"
                color="info"
                onClick={handleOpenFormModal}
                sx={{ margin: " auto 20px auto 0px" }}
              >
                Editar entrevista
              </Button>
            </Box>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default EntrevistasItem;
